import script from "./SimpleBusinessTableContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./SimpleBusinessTableContent.vue?vue&type=script&lang=ts&setup=true"

import "./SimpleBusinessTableContent.vue?vue&type=style&index=0&id=1f08373c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f08373c"]])

export default __exports__